import React from 'react'
import { Table, Menu, ActionIcon } from '@mantine/core'
import { IconDotsVertical, IconPencil, IconTrash } from '@tabler/icons-react'
import dayjs from 'dayjs'

const detaultPointType = {
  1: {
    name: 'Point Adjustment',
    type: 'increase',
  },
  2: {
    name: 'Point Adjustment',
    type: 'decrease',
  },
  3: {
    name: 'Point Reward',
    type: 'increase',
  },
  4: {
    name: 'Bonus Point',
    type: 'increase',
  },
  5: {
    name: 'Redeem',
    type: 'decrease',
  },
}

const ActionMenu = ({ handleAction, detail }) => {
  return (
    <Menu width={200} position="bottom-end" withArrow arrowPosition="center">
      <Menu.Target>
        <ActionIcon ml={8} pt={6} variant='transparent' size='xs'>
          <IconDotsVertical stroke={1.5} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconPencil stroke={1.5} size={14} />}
          onClick={() => handleAction('edit')}
          fw='600'
          fz={11}
        >
          Edit
        </Menu.Item>
        <Menu.Item
          color='red'
          leftSection={<IconTrash stroke={1.5} size={14} />}
          onClick={() => handleAction('delete')}
          fw='600'
          fz={11}
        >
          Delete
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}

const TableUserPoint = ({ label, data, actionMethod }) => {
  const mappingTableHead = (data) => data.map((val, index) => {
    return (<Table.Th key={index} width={val.width !== 'auto' ? val.width : ''}>{val.label}</Table.Th>)
  })

  const mappingDataTable = (data) => data.map((val, index) => {
    return (
      <Table.Tr key={index}>
        <Table.Td>{index + 1}</Table.Td>
        <Table.Td>{dayjs(val.updated_at).format('DD MMMM YYYY')}</Table.Td>
        <Table.Td>{val.order_id ? `Order ref ID ${val.order_id}` : '-'}</Table.Td>
        <Table.Td c={val.reward_type.value !== 2 && val.reward_type.value !== 5 ? 'green' : 'red'}>
          {val.reward_type.value ? detaultPointType[val.reward_type.value].name : '-'}
        </Table.Td>
        <Table.Td>{val.reward_type.label ? val.reward_type.label : '-'}</Table.Td>
        <Table.Td c={val.reward_type.value !== 2 && val.reward_type.value !== 5 ? 'green' : 'red'}>
          {val.reward_type.value !== 2 && val.reward_type.value !== 5 ? '+ ' : '- '} {val.amount || 0}
        </Table.Td>
        <Table.Td><ActionMenu handleAction={(type) => actionMethod(val, type)} detail={val} /></Table.Td>
      </Table.Tr>
    )
  })
  return (
    <Table.ScrollContainer minWidth={1366} type='native'>
      <Table highlightOnHover withTableBorder style={{ fontSize: '13px' }}>
        <Table.Thead style={{ backgroundColor: '#eeefef' }}>
          <Table.Tr>
            {mappingTableHead(label)}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody style={{ verticalAlign: 'top' }}>
          {mappingDataTable(data)}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  )
}

export default TableUserPoint